/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Indicator/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconDescription from 'DesignSystem/Svgs/TysiaIconDescription/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Indicator({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Note/Loading/Indicator"
  
}) {
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<div
  data-testid="Indicator.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Indicator.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-1-1wiWS0': dtColorsNeutral200}}
 className={`views-block ${styles.Vertical1}`}
/>
<div
  data-testid="Indicator.Vertical:2"
  data-view-path={viewPath}
 style={{'--bc-2-1wiWS0': dtColorsWhite,'--bblr-3-1wiWS0': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bbrr-4-1wiWS0': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--btlr-5-1wiWS0': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--btrr-6-1wiWS0': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--oc-7-1wiWS0': typeof dtColorsWhite === 'number' ? `${dtColorsWhite}px` : dtColorsWhite,'--bc-1-1wiWS0': dtColorsNeutral400}}
 className={`views-block ${styles.Vertical2}`}
>
<TysiaIconDescription
  viewPath={`${viewPath}/TysiaIconDescription`}
 fill={dtColorsNeutral400}
 height={16}
 width={16}
/>
</div>
</div>
{children}
</React.Fragment>)
}